import type { GuardianPlayerSessionsParams } from '@/features/guardian-player/services';

export const guardianPlayerKeys = {
  all: ['guardianPlayer'] as const,
  playerDetail: (playerId: string) =>
    [...guardianPlayerKeys.all, 'playerDetail', playerId] as const,
  sessionSummary: (playerId: string) =>
    [...guardianPlayerKeys.all, 'sessionSummary', playerId] as const,
  sessions: (
    playerId: string,
    params?: Pick<GuardianPlayerSessionsParams, 'limit' | 'cursor' | 'paginate'>,
  ) =>
    [
      ...guardianPlayerKeys.all,
      'sessions',
      playerId,
      params?.limit ?? null,
      params?.cursor ?? null,
      params?.paginate ?? null,
    ] as const,
  sessionDetail: (playerId: string, sessionId: string) =>
    [...guardianPlayerKeys.all, 'sessionDetail', playerId, sessionId] as const,
} as const;
